import client from '@efex-services/axios';
import {
  UpdateBeneficiaryServiceRequest,
  UpdateBeneficiaryServiceResponse,
} from '../types';

const updateBeneficiary = async ({
  token,
  action,
}: UpdateBeneficiaryServiceRequest): Promise<UpdateBeneficiaryServiceResponse> =>
  client.post(`contact-status/${action}/${token}/`);

const BENEFICIARY_SVC = { updateBeneficiary };

export default BENEFICIARY_SVC;
